import * as React$1 from "react";
import { cn } from "@synthesis/shared-utils";
import { jsx, jsxs } from "react/jsx-runtime";
import { ScrollArea as ScrollArea$1 } from "@base-ui/react/scroll-area";
//#region src/ScrollArea/index.tsx
/**
* Компонент ScrollArea
* Дизайн - https://www.figma.com/file/lixEouzSvWhAf04wpHXkIo/%D0%A0%D0%96%D0%94.-UI-Kit?node-id=5295%3A10158&t=OAvN7ARUzHnki0MD-1
* @param className - дополнительные стили для viewport
* @param children - элементы, которые будут отображаться внутри компонента
*/
const { Root, Viewport, Content, Scrollbar, Thumb, Corner } = ScrollArea$1;
const scrollbarClassName = cn("hover:bg-neutrals-90/50 z-40 flex touch-none select-none rounded-[10px] bg-transparent p-0.5 transition-colors duration-[160ms] ease-out", "data-[orientation=horizontal]:h-3 data-[orientation=vertical]:w-3 data-[orientation=horizontal]:flex-col", "data-[state=checked]:bg-brand-40", "pointer-events-none opacity-0 transition-opacity duration-[160ms] ease-out", "data-[hovering]:pointer-events-auto data-[hovering]:opacity-100", "data-[scrolling]:pointer-events-auto data-[scrolling]:opacity-100");
const thumbClassName = cn("bg-neutrals-80 relative flex-1 rounded-[10px]", "before:absolute before:left-1/2 before:top-1/2 before:h-full before:min-h-[12px] before:w-full before:min-w-[12px] before:-translate-x-1/2 before:-translate-y-1/2 before:content-[\"\"]");
const ScrollArea = React$1.forwardRef(({ className, children, direction = "both", rootClassName, ...props }, ref) => /* @__PURE__ */ jsxs(Root, {
	className: cn("overflow-hidden", rootClassName),
	"data-direction": direction,
	...props,
	children: [
		/* @__PURE__ */ jsx(Viewport, {
			"data-cy": "scrollArea-viewport",
			ref,
			className: cn("h-full w-full", className),
			style: props["style"],
			children: /* @__PURE__ */ jsx(Content, {
				className: cn(direction === "vertical" && "block"),
				children
			})
		}),
		(direction === "vertical" || direction === "both") && /* @__PURE__ */ jsx(Scrollbar, {
			orientation: "vertical",
			className: scrollbarClassName,
			children: /* @__PURE__ */ jsx(Thumb, { className: thumbClassName })
		}),
		(direction === "horizontal" || direction === "both") && /* @__PURE__ */ jsx(Scrollbar, {
			orientation: "horizontal",
			className: scrollbarClassName,
			children: /* @__PURE__ */ jsx(Thumb, { className: thumbClassName })
		}),
		/* @__PURE__ */ jsx(Corner, { className: "bg-transparent" })
	]
}));
ScrollArea.displayName = "ScrollArea";
//#endregion
export { ScrollArea };

//# sourceMappingURL=index.js.map